const MALE_CONSTANT = 5;
const FEMALE_CONSTANT = -161;

export const MALE = 'MALE';
export const FEMALE = 'FEMALE';

export const SexCoefficient = Object.freeze({
    MALE: MALE_CONSTANT,
    FEMALE: FEMALE_CONSTANT
});
